import React from "react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

export default function Account() {
  const { user, logout } = useAuth();
  if (!user) return null;
  return (
    <div className="App min-h-screen">
      <Navbar />
      <div className="max-w-3xl mx-auto px-6 lg:px-8 py-10">
        <div className="text-xs tracking-widest-2 uppercase text-muted-foreground font-semibold mb-2">Account</div>
        <h1 className="font-heading font-black tracking-tighter text-4xl md:text-5xl mb-8">Your details.</h1>
        <div className="border border-border bg-white p-6 space-y-4">
          <div className="flex items-center gap-4">
            {user.picture && <img src={user.picture} alt="" className="h-14 w-14 rounded-full" />}
            <div>
              <div className="font-semibold">{user.name}</div>
              <div className="text-sm text-muted-foreground">{user.email}</div>
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4 text-sm border-t border-border pt-4">
            <div>
              <div className="text-muted-foreground text-xs uppercase tracking-widest-2 mb-1">Role</div>
              <div className="font-mono">{user.role}</div>
            </div>
            <div>
              <div className="text-muted-foreground text-xs uppercase tracking-widest-2 mb-1">Status</div>
              <div className="font-mono">{user.is_active ? "active" : "deactivated"}</div>
            </div>
          </div>
          <div className="border-t border-border pt-4 flex flex-wrap gap-2">
            <Button variant="outline" data-testid="account-logout-all" onClick={async () => { await import("@/lib/api").then(m => m.default.post("/auth/logout-all")); window.location.href = "/"; }} className="rounded-sm">
              Log out of all devices
            </Button>
            <Button variant="ghost" data-testid="account-logout" onClick={logout} className="rounded-sm">Log out</Button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
